import { Button } from '@/app/ui/components/button';
import { Link } from '@tanstack/react-router';

export function NotFound() {
  return (
    <div className="flex grow flex-col items-center pt-20 text-center md:pt-40">
      <h1 className="mb-2 text-xl">Not found</h1>
      <p className="mb-5 text-lg opacity-70">
        This page does not exist — <br /> it may have been moved or deleted.
      </p>
      <Button nativeButton={false} render={<Link to={'/'}>Back home</Link>} />
    </div>
  );
}
